export class DestinationStrings {

  static deleteTableTitle = 'Are you Sure? 😱';
  static deleteTablePstBtn = 'Delete';
  static deleteTableNgtBtn = 'Cancel';

  static deleteDestinationTitle = 'Delete Destination?';
  static deleteDestinationBody = 'Are you sure you want to delete this Destination?';
  static deleteDestinationBodyWithWebhooks = 'Are you sure you want to delete this Destination? Any Webhook events created for this Destination will also be deleted.';
  static deleteDestinationPositiveBtn = 'Delete';
  static deleteDestinationNegativeBtn = 'Cancel';

  static reauthoriseWarningBody = 'Do you have the required permissions to read and write data for this Destination?' +
    ' The connected Pipelines and Activations may fail if you do not have the required permissions.';

  static editReAuthText = 'Reauthorize account in order to change settings';

  static deleteDestinationTooltip = 'Destination cannot be deleted, as there are Pipelines, Models, or Activations associated with it.';

  static disableDedupDestination = {
    title: 'Disable Append Rows on Update',
    body: 'Hevo will update existing rows when new records arrive for them from the Source. ' +
      'The rows are matched for updates based on the primary keys in the table.<br><br> ' +
      'Do you wish to continue?'
  };

  static enableDedupDestination = {
    title: 'Enable Append Rows on Update',
    body: 'Hevo will no longer update existing rows, rather it will add new rows to the table for updates. ' +
      'This will result in multiple rows in the table for the same primary keys.<br><br> ' +
      'Do you wish to continue?',
  };

  static confirmDisabledDedup = {
    title: 'Auto Updates are Off',
    body: 'Hevo will create a row for each update on an existing row. ' +
      'We recommend switching off Auto Updates only when your Sources are appending new rows and not updating the old ones. ' +
      'Are you sure you want to do this?',
    confirmBtn: 'YES, I AM SURE',
    cancelBtn: 'NO, SWITCH IT ON'
  };

  static connectBIToolsDisabledText = 'Only the creator of this Destination can connect a BI tool.';

  static deleteTableBody(tableName: string) {
    return 'The Table <b>' + tableName + '</b> ' +
      'will be permanently deleted from the Destination. ' +
      'You will lose all the data currently stored in it from any Source. ' +
      'This operation cannot be undone.';
  }

  static deleteTableSuccess(tableName: string) {
    return 'Table ' + tableName + ' was successfully deleted from the Destination';
  }
}

export const TRIGGER_BASED_LOAD_ERROR_TOOLTIP_TITLE =
  'The last frequency change is not applied. Please try editing the frequency again';
